/** @format */

export const PREFIX_UPLOAD_STATUS = {
    STATUS_IMPORT_AWAIT: 1,
    STATUS_IMPORT_PROCESS: 2,
    STATUS_IMPORT_FINISH: 3,
    STATUS_ERROR: 4,
};

export const getPrefixUploadFileStatus = (status: number): string => {
    switch (status) {
        case PREFIX_UPLOAD_STATUS.STATUS_IMPORT_AWAIT:
            return 'prefixes:upload.status_uploaded';
        case PREFIX_UPLOAD_STATUS.STATUS_IMPORT_PROCESS:
            return 'prefixes:upload.status_import_process';
        case PREFIX_UPLOAD_STATUS.STATUS_IMPORT_FINISH:
            return 'prefixes:upload.status_imported';
        case PREFIX_UPLOAD_STATUS.STATUS_ERROR:
            return 'prefixes:upload.status_error';
        default:
            return 'prefixes:upload.status_unknown';
    }
};
